<template>
  <div id="everything-fandoms">
    <div v-if="updating" class="loader">
      <div class="loading loading-lg"></div>
    </div>

    <template v-else>
      <div class="scroll-top" @click="scrollToTop">(^)</div>

      <div></div>

      <h3>All Fandoms</h3>
      <div class="input-group">
        <span class="input-group-addon">Filter</span>
        <input class="form-input" type="text" id="fandom-filter" placeholder="Search fandom list..."
          v-model="everythingFilter" />
      </div>
      <p>
        <small>Fandom list is loaded as you scroll, but the filter works on
          everything.</small>
      </p>

      <ul>
        <li v-for="fandom in everythingFiltered" :key="'main-list' + fandom.name">
          <router-link :to="`/everything/fandom/${encodeURIComponent(fandom.name)}`">
            {{ fandom.name }}
          </router-link>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { filter, sortBy, map } from "lodash-es";
import { mapGetters } from "vuex";
import axios from "axios";

// Remove english articles from fandom names
function removeArticlesCompare(o) {
  if (!o) {
    return;
  }
  const regex = /^(the\s|a\s|an\s)/i;
  if (!o.name) {
    return o;
  }
  return o.name.toLowerCase().replace(regex, "");
}

export default {
  name: "everything-fandoms",
  mounted() {
    this.load();
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    this.load();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      updating: true,
      fandom: "",
      filtered: [],
      sstring: "",
      view: "",
      limit: false,
      toggle: true,
      everythingFilter: "",
      everythingFiltered: [],
      hasSearchError: false,
      fandomFilter: undefined,
      searchOption: "",
      scrollIndex: 50,
      totalFound: 0,
    };
  },
  computed: {
    ...mapGetters(["everythingFandoms", "exchanges"]),
  },
  watch: {
    $route(to) {
      if (to.name == "everything-fandoms") {
        this.$store.commit("setExchangeId", "");
        this.load();
      }
    },
    everythingFilter() {
      this.updateEverythingFandoms();
    },

    limit() {
      this.load();
    },
  },
  methods: {
    updateEverythingFandoms() {
      if (!this.everythingFilter || !this.everythingFilter.length) {
        this.everythingFiltered = this.everythingFandoms.slice(
          0,
          this.scrollIndex
        );
        return;
      }
      this.everythingFiltered = filter(this.everythingFandoms, (o) => {
        const name = o.name
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        return name.indexOf(this.everythingFilter.toLowerCase()) > -1;
      }).slice(0, this.scrollIndex);
    },
    handleScroll() {
      if (!this.everythingFandoms) return;

      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;

      if (
        scrollTop + clientHeight >= scrollHeight - 5 &&
        this.everythingFandoms.length > this.scrollIndex
      ) {
        const newIndex = this.scrollIndex + 50;
        if (newIndex < this.everythingFandoms.length) {
          this.scrollIndex = newIndex;
        } else {
          this.scrollIndex = this.everythingFandoms.length;
        }
      }

      this.updateEverythingFandoms();
    },
    load() {
      this.updating = true;

      this.prompts = [];
      this.filtered = [];

      if (!this.everythingFandoms || !this.everythingFandoms.length) {
        axios
          .get(`https://autoao3.herokuapp.com/db/fandoms/requested`)
          .then((res) => {
            let data = map(
              filter(res.data, (d) => d.fandom && d.fandom.length),
              (f) => {
                f.name = f.fandom;
                delete f.fandom;
                return f;
              }
            );

            data = sortBy(data, [removeArticlesCompare]);

            this.$store.commit("setEverythingFandoms", data);
            this.updateEverythingFandoms();
          })
          .catch((e) => { })
          .finally(() => {
            this.updating = false;
          });
      } else {
        this.updating = false;
      }
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style lang="scss">
@import "../styles/app.scss";
@import "../styles/mobile.scss";
</style>


<style lang="scss" scoped>
@import "../styles/variables.scss";

.field-select {
  flex: 0 1 auto;
  width: 33%;
}

.prompt {
  margin: 0.8em 0;
  // border-bottom: 1px solid $outline-light;

  &:last-child {
    .break {
      display: none;
    }
  }
}

.bookmark,
.letter {
  height: 1.3em;
}

.user-data {
  font-size: larger;

  .letter {
    padding: 0;
    margin: 0;
    vertical-align: baseline;
  }

  .bookmark {
    position: relative;
    bottom: 4px;
    margin-right: 0.4em;
  }
}

.flex {
  margin-top: 0.4em;
  display: flex;
}

ul {
  li {
    margin: 0;
    padding: 4px 0;
    border-bottom: 1px solid $outline-light;

    &:last-child {
      border: 0;
    }

    &:first-child {
      padding-top: 0;
    }
  }
}

.requested-characters {
  // margin-top: 1em;
  margin-right: 1em;
  flex: 0 0 25%;
}

.toggle {
  width: 150px;
  height: 35px;
  display: block;
}

.break {
  width: 80%;
  margin: 0.8em auto;
}

@media screen and (max-width: 767px) {
  .flex {
    display: inherit;
  }

  .requested-characters {
    display: block;
    margin-bottom: 0.5em;
  }
}
</style>